import script from "./ChangeLanguageBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeLanguageBtn.vue?vue&type=script&setup=true&lang=js"

import "./ChangeLanguageBtn.vue?vue&type=style&index=0&id=45626238&scoped=true&lang=scss"

import exportComponent from "D:\\citbooks-fore-end20251021\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45626238"]])

export default __exports__